import { useQuery } from '@tanstack/react-query';
import { favoritesApi } from '@/features/favorites/api/favoritesApi';
import { Place } from '@/types/place';

/**
 * Hook to fetch all user favorites once using TanStack Query.
 * Returns favorites array, loading state, error state, and refetch function.
 * 
 * Query key: ['userFavorites', userId]
 * Only enabled when userId exists and is not empty.
 */
export const useUserFavorites = (userId: string | null) => {
  return useQuery<Place[]>({
    queryKey: ['userFavorites', userId],
    queryFn: () => favoritesApi.getUserFavorites(userId!),
    enabled: !!userId && userId.trim() !== '',
    staleTime: 5 * 60 * 1000, // 5 minutes - favorites don't change frequently
  });
};
